/* =========================================================
   Alba & Flavia — JavaScript do tema (sem dependências)
   ========================================================= */
(function () {
  'use strict';

  var AF = window.AF || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Drawers & overlay ---------------- */
  var overlay = null;
  var activeDrawer = null;
  var lastFocus = null;

  function openDrawer(drawer, trigger) {
    if (!drawer) return;
    if (activeDrawer && activeDrawer !== drawer) closeDrawer(activeDrawer, true);
    overlay = overlay || $('[data-overlay]');
    lastFocus = trigger || document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    activeDrawer = drawer;
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusTarget = $('[data-drawer-close]', drawer) || drawer;
    setTimeout(function () { focusTarget.focus(); }, 60);
  }

  function closeDrawer(drawer, keepOverlay) {
    drawer = drawer || activeDrawer;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!keepOverlay && overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.hidden = true; }, 300);
    }
    document.body.classList.remove('is-locked');
    activeDrawer = null;
    if (!keepOverlay && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); openDrawer(target, opener); }
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) {
      closeDrawer();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (activeModal) closeModal();
    else if (activeDrawer) closeDrawer();
    closeAllMenus();
  });

  /* ---------------- Modais ---------------- */
  var activeModal = null;
  function openModal(modal, trigger) {
    if (!modal) return;
    activeModal = modal;
    modal.hidden = false;
    modal._trigger = trigger;
    document.body.classList.add('is-locked');
    var close = $('.modal__close', modal);
    if (close) close.focus();
  }
  function closeModal() {
    if (!activeModal) return;
    activeModal.hidden = true;
    if (!activeDrawer) document.body.classList.remove('is-locked');
    if (activeModal._trigger) activeModal._trigger.focus();
    activeModal = null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-modal-open]');
    if (t) { e.preventDefault(); openModal(document.getElementById(t.getAttribute('data-modal-open')), t); return; }
    if (e.target.closest('[data-modal-close]')) closeModal();
  });

  /* ---------------- Barra de anúncios ---------------- */
  function initAnnouncements(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar._init) return; bar._init = true;
      var items = $$('.announcement__item', bar);
      if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
      var i = 0; var timer;
      var inline = bar.classList.contains('announcement--inline') && window.matchMedia('(min-width: 990px)');
      function show(n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      function start() { stop(); if (!reduceMotion) timer = setInterval(function () { show(i + 1); }, (parseInt(bar.dataset.speed, 10) || 5) * 1000); }
      function stop() { clearInterval(timer); }
      items[0].classList.add('is-active');
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      if (!inline || !inline.matches) start();
    });
  }

  /* ---------------- Header fixo ---------------- */
  function initStickyHeader() {
    var wrap = $('[data-header-wrapper]');
    if (!wrap || !wrap.classList.contains('header-wrapper--sticky')) return;
    var stickyEl = wrap.closest('.header-section') || wrap;
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.setAttribute('aria-hidden', 'true');
    stickyEl.parentNode.insertBefore(sentinel, stickyEl);
    new IntersectionObserver(function (entries) {
      wrap.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  /* ---------------- Navegação desktop ---------------- */
  function closeAllMenus(except) {
    $$('.nav__item.is-open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var b = $('.nav__link', item); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function initNav() {
    var nav = $('[data-nav]');
    if (!nav) return;
    var hover = nav.dataset.hover === 'true';
    $$('.nav__item--has-children', nav).forEach(function (item) {
      var btn = $('.nav__link', item);
      var t;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !item.classList.contains('is-open');
        closeAllMenus(item);
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
      if (hover) {
        item.addEventListener('mouseenter', function () { clearTimeout(t); closeAllMenus(item); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); });
        item.addEventListener('mouseleave', function () { t = setTimeout(function () { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 150); });
      }
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-nav]')) closeAllMenus(); });
  }

  /* ---------------- Pesquisa no header ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    var bar = document.getElementById('HeaderSearch');
    if (!bar) return;
    e.preventDefault();
    bar.hidden = !bar.hidden;
    t.setAttribute('aria-expanded', String(!bar.hidden));
    if (!bar.hidden) { var input = $('input[type="search"]', bar); if (input) input.focus(); }
  });

  /* ---------------- Slideshow ---------------- */
  function initSlideshows(root) {
    $$('[data-slideshow]', root).forEach(function (el) {
      if (el._init) return; el._init = true;
      var track = $('.slideshow__track', el);
      var slides = $$('.slide', el);
      var dots = $$('.slideshow__dot', el);
      if (slides.length < 2) return;
      var index = 0; var timer;
      function go(n) {
        index = (n + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function setActive(n) { dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === n)); }); }
      track.addEventListener('scroll', function () {
        var n = Math.round(track.scrollLeft / track.clientWidth);
        if (n !== index) { index = n; }
        setActive(n);
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
      function restart() {
        clearInterval(timer);
        if (el.dataset.autoplay === 'true' && !reduceMotion) timer = setInterval(function () { go(index + 1); }, (parseInt(el.dataset.speed, 10) || 5) * 1000);
      }
      el.addEventListener('mouseenter', function () { clearInterval(timer); });
      el.addEventListener('mouseleave', restart);
      el.addEventListener('focusin', function () { clearInterval(timer); });
      setActive(0); restart();
    });
  }

  /* ---------------- Carrinho ---------------- */
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) throw data; return data; });
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; el.dataset.count = count; });
  }

  function refreshCartDrawer(open) {
    var drawer = document.getElementById('CartDrawer');
    return fetch(AF.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!drawer || !data['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          var c = fresh.getAttribute('data-count');
          if (c !== null) updateCount(parseInt(c, 10));
        }
        if (open) openDrawer(drawer);
      });
  }

  function afterCartChange(openAfter) {
    if (AF.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      return refreshCartDrawer(openAfter);
    }
    if (openAfter) { window.location.href = AF.routes.cart; return Promise.resolve(); }
    return fetchJSON(AF.routes.cart + '.js').then(function (cart) { updateCount(cart.item_count); });
  }

  // Formulário de produto (AJAX)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (AF.cartType !== 'drawer' && !form.hasAttribute('data-ajax')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var errorBox = $('[data-form-error]', form.closest('[data-af-product-section]') || form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (errorBox) errorBox.hidden = true;
    fetchJSON(AF.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function () {
      document.dispatchEvent(new CustomEvent('af:cart:added'));
      return afterCartChange(true);
    }).catch(function (err) {
      if (errorBox) { errorBox.textContent = (err && (err.description || err.message)) || AF.strings.error; errorBox.hidden = false; }
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  });

  function changeLine(key, quantity, container) {
    if (container) container.classList.add('is-updating');
    return fetchJSON(AF.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () { return afterCartChange(false); })
      .catch(function (err) { alert((err && err.description) || AF.strings.error); })
      .finally(function () { if (container) container.classList.remove('is-updating'); });
  }

  // Quantidades
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty');
      var input = $('input', wrap);
      var min = parseInt(input.min || '0', 10);
      var val = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var remove = e.target.closest('[data-cart-remove]');
    if (remove && remove.closest('#CartDrawer')) {
      e.preventDefault();
      changeLine(remove.dataset.cartRemove, 0, remove.closest('.cart-item'));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    if (input.closest('#CartDrawer')) {
      changeLine(input.dataset.cartQty, parseInt(input.value, 10) || 0, input.closest('.cart-item'));
    } else if (input.closest('[data-cart-page-form]')) {
      clearTimeout(input._t);
      input._t = setTimeout(function () { input.form.submit(); }, 450);
    }
  });

  /* ---------------- Produto ---------------- */
  function initProducts(root) {
    $$('[data-af-product-section]', root).forEach(function (section) {
      if (section._init) return; section._init = true;
      var jsonEl = $('[data-product-json]', section);
      if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var form = $('[data-product-form]', section);
      var idInput = form ? $('input[name="id"]', form) : null;
      var gallery = $('[data-gallery]', section);

      initGallery(gallery);

      function selectedOptions() {
        return $$('[data-option-position]', section).map(function (group) {
          var checked = $('input:checked', group);
          if (checked) return checked.value;
          var sel = $('select', group);
          return sel ? sel.value : null;
        });
      }

      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function markAvailability(opts) {
        $$('[data-option-position]', section).forEach(function (group, gi) {
          $$('input[type="radio"]', group).forEach(function (input) {
            var test = opts.slice(); test[gi] = input.value;
            var v = findVariant(test);
            input.classList.toggle('is-unavailable', !v || !v.available);
          });
          var sel = $('select', group);
          if (sel) $$('option', sel).forEach(function (o) {
            var test = opts.slice(); test[gi] = o.value;
            var v = findVariant(test);
            o.textContent = o.value + ((!v || !v.available) ? ' — ' + AF.strings.soldOut : '');
          });
        });
      }

      function update() {
        var opts = selectedOptions();
        var variant = findVariant(opts);
        markAvailability(opts);
        $$('[data-option-position]', section).forEach(function (group, gi) {
          var lbl = $('[data-selected-value]', group); if (lbl) lbl.textContent = opts[gi];
        });
        var btn = form ? $('[type="submit"]', form) : null;
        if (!variant) {
          if (btn) { btn.disabled = true; $('span', btn).textContent = AF.strings.unavailable; }
          return;
        }
        if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        if (btn) {
          btn.disabled = !variant.available;
          $('span', btn).textContent = variant.available ? AF.strings.addToCart : AF.strings.soldOut;
        }
        // Preço e restantes blocos: re-render através da Section Rendering API
        var url = product.url + '?variant=' + variant.id + '&section_id=' + section.dataset.sectionId;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price-wrapper]', '[data-inventory]', '[data-sku]', '[data-pickup]'].forEach(function (sel) {
            var fresh = $(sel, doc); var cur = $(sel, section);
            if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          });
        }).catch(function () {});
        if (variant.featured_media && gallery) gallery._goToMedia(variant.featured_media.id);
        if (section.dataset.updateUrl !== 'false' && window.history.replaceState) {
          window.history.replaceState({}, '', product.url + '?variant=' + variant.id);
        }
        section.dispatchEvent(new CustomEvent('af:variant:change', { bubbles: true, detail: { variant: variant } }));
      }

      section.addEventListener('change', function (e) {
        if (e.target.closest('[data-option-position]')) update();
      });
      markAvailability(selectedOptions());
    });
  }

  function initGallery(gallery) {
    if (!gallery) return;
    var viewport = $('.gallery__viewport', gallery);
    var slides = $$('.gallery__slide', gallery);
    var thumbs = $$('.gallery__thumb', gallery);
    var counter = $('[data-gallery-counter]', gallery);
    var current = 0;

    function setCurrent(n) {
      current = n;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === n)); });
      if (thumbs[n]) thumbs[n].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (counter) counter.textContent = (n + 1) + ' / ' + slides.length;
      slides.forEach(function (s, k) { var v = $('video', s); if (v && k !== n) v.pause(); });
    }
    function go(n, instant) {
      n = (n + slides.length) % slides.length;
      viewport.scrollTo({ left: slides[n].offsetLeft, behavior: (instant || reduceMotion) ? 'auto' : 'smooth' });
      setCurrent(n);
    }
    gallery._goToMedia = function (mediaId) {
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (idx > -1) go(idx);
    };
    var raf;
    viewport.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var n = Math.round(viewport.scrollLeft / viewport.clientWidth);
        if (n !== current) setCurrent(n);
      });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('.gallery__arrow--prev', gallery); var next = $('.gallery__arrow--next', gallery);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    var start = parseInt(gallery.dataset.start || '0', 10);
    if (start > 0) requestAnimationFrame(function () { go(start, true); }); else setCurrent(0);
  }

  /* ---------------- Recomendações ---------------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el._init) return; el._init = true;
      var url = el.dataset.url;
      if (!url) return;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-recommendations]', doc);
          if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
          else el.closest('.shopify-section').hidden = true;
        });
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(el);
    });
  }

  /* ---------------- Coleção: filtros e ordenação ---------------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-select]');
    if (sort) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }
    var filter = e.target.closest('[data-filter-form] input[type="checkbox"]');
    if (filter && filter.form.dataset.autoSubmit === 'true') filter.form.submit();
  });


  /* ---------------- Fase 2: anteprima rapida ---------------- */
  function withSection(url, id) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    var modal = document.getElementById('QuickView');
    if (!modal) { window.location.href = btn.dataset.quickView; return; }
    var box = $('[data-quick-view-content]', modal);
    box.innerHTML = '<p class="quick-view__loading">' + (AF.strings.loading || '…') + '</p>';
    openModal(modal, btn);
    fetch(withSection(btn.dataset.quickView, 'quick-view'))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        box.innerHTML = html;
        initProducts(box);
        var close = $('.modal__close', modal); if (close) close.focus();
      })
      .catch(function () { window.location.href = btn.dataset.quickView; });
  });
  document.addEventListener('af:cart:added', function () {
    var modal = document.getElementById('QuickView');
    if (modal && !modal.hidden && activeModal === modal) closeModal();
  });

  /* ---------------- Fase 2: pesquisa preditiva ---------------- */
  function initPredictive() {
    var input = $('[data-predictive-input]');
    var output = $('[data-predictive-output]');
    if (!input || !output || !AF.predictiveSearch || input._init) return;
    input._init = true;
    var timer, controller;
    function hide() { output.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = AF.routes.predictive + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6' +
          '&resources[options][unavailable_products]=last&section_id=predictive-search';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = $('[data-predictive-results]', doc);
            if (!res || !res.innerHTML.trim()) { hide(); return; }
            output.innerHTML = res.innerHTML;
            output.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          }).catch(function () {});
      }, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
      if (e.key === 'ArrowDown' && !output.hidden) { var first = $('a', output); if (first) { e.preventDefault(); first.focus(); } }
    });
    output.addEventListener('keydown', function (e) {
      var links = $$('a', output); var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) links[i - 1].focus(); else input.focus(); }
      if (e.key === 'Escape') { hide(); input.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-predictive-output]') && !e.target.closest('[data-predictive-input]')) hide();
    });
  }

  /* ---------------- Fase 2: vistos recentemente ---------------- */
  var RECENT_KEY = 'af_recently_viewed';
  function readRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; } }
  function recordRecent() {
    var main = $('[data-af-product-section]:not([data-section-id="quick-view"]) [data-product-json]');
    if (!main) return;
    try {
      var handle = JSON.parse(main.textContent).handle;
      var list = readRecent().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  function initRecent(root) {
    $$('[data-recently-viewed]', root).forEach(function (el) {
      if (el._init) return; el._init = true;
      var limit = parseInt(el.dataset.limit, 10) || 5;
      var handles = readRecent().filter(function (h) { return h !== el.dataset.current; }).slice(0, limit);
      if (!handles.length) return;
      var list = $('[data-recently-viewed-list]', el);
      var base = AF.routes.root.replace(/\/$/, '');
      Promise.all(handles.map(function (h) {
        return fetch(base + '/products/' + encodeURIComponent(h) + '?section_id=product-card-render')
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        var count = 0;
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = $('[data-card-render]', doc);
          if (!card) return;
          var li = document.createElement('li'); li.innerHTML = card.innerHTML; list.appendChild(li); count++;
        });
        if (count) el.hidden = false;
      });
    });
  }

  /* ---------------- Init ---------------- */
  function init(root) {
    initAnnouncements(root);
    initSlideshows(root);
    initProducts(root);
    initRecommendations(root);
    initRecent(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initStickyHeader();
    initNav();
    initPredictive();
    recordRecent();
  });

  // Editor de temas do Shopify
  document.addEventListener('shopify:section:load', function (e) { init(e.target); if (e.target.querySelector('[data-nav]')) { initNav(); initPredictive(); } });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.slide');
    if (slide) { var track = slide.parentNode; track.scrollTo({ left: slide.offsetLeft }); }
  });

  window.AF.openDrawer = openDrawer;
  window.AF.closeDrawer = closeDrawer;
  window.AF.refreshCart = function () { return afterCartChange(false); };
})();
